import React, { FC } from 'react'
import Page from 'modules/common/Page'
import PresentationPageContent, { PresentationPageContentProps } from 'modules/material/PresentationPageContent'
import { MaterialApi } from '@libs/api'
import { GetServerSideProps } from 'next'
import PresentationMaterialNotFound from 'modules/material/PresenatationMaterialNotFound'

const PresentationPage: FC<PresentationPageContentProps> = ({ notFound, ...presentationProps }) =>
	notFound ? (
		<PresentationMaterialNotFound {...presentationProps} />
	) : (
		<Page layout="basic" titleKey="presentation">
			<PresentationPageContent {...presentationProps} />
		</Page>
	)

export const getServerSideProps: GetServerSideProps = async context => {
	const visualParams = context.query as { caseId: string; filter: string }

	const { materials } = await MaterialApi.getSimplifiedVisualMaterials(visualParams.caseId)
	const filteredMaterials = materials
		.filter(({ isActive }) => (visualParams.filter === 'active' ? isActive : true))
		.map(item => {
			// hide property to avoid date serialization issues
			delete item.updatedDate
			return item
		})

	if (!filteredMaterials.length) {
		context.res.statusCode = 404

		return {
			props: {
				notFound: true,
				...visualParams,
				visualMaterials: filteredMaterials,
			},
		}
	}

	return {
		props: {
			...visualParams,
			visualMaterials: filteredMaterials,
		},
	}
}

export default PresentationPage
